import React from "react";

const { FadeLoader } = require("halogenium");

export default function Loading() {
  return <FadeLoader size='50px' margin='4px' />;
}
